module.exports = __webpack_public_path__ + "img/addition.2f4f5a82.svg";